<template>
  <v-container class="kezdolap" :style="bgColor" fluid>
    <top-bar></top-bar>
    <div class="page-content">
      <iframe
        :src="headerSrc"
        v-if="headerSrc && !isMobile"
        class="iframe header-iframe"
        v-iresize="{ log: false }"
      ></iframe>
    </div>
    <p class="grey--text text--darken-2 mb-3" v-if="isMobile">
      {{ new Date() | toLongDateFancy }}
    </p>
    <div class="page-content">
      <fooldal-mobile-layout v-if="isMobile"></fooldal-mobile-layout>
      <fooldal-desktop-layout v-else></fooldal-desktop-layout>
    </div>

    <div class="page-content">
      <iframe
        :src="footerSrc"
        v-if="footerSrc"
        class="iframe footer-iframe"
        v-iresize="{ log: false }"
      ></iframe>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../functions/AppFunctions';
import settings from '../settings';
import { AppStoreTypes } from '../store/modules/app';

export default {
  name: 'Fooldal',
  data() {
    return {
      headerContent: '',
      footerContent: '',
    };
  },
  setup() {},
  activated() {},
  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({
      user: AppStoreTypes.user.get,
      linkek: AppStoreTypes.linkek.getAll,
    }),
    aktualisProjekt() {
      return this.user?.Projekt;
    },
    bgColor() {
      return AppFunctions.GetBgColorStyle(this.user);
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    headerSrc() {
      if (!this.aktualisProjekt?.HeaderContent) {
        return null;
      }
      return (
        settings.baseUrl +
        'Api/Projekt/GetHeaderContentByProjectId/?projectId=' +
        this.aktualisProjekt.Id
      );
    },
    footerSrc() {
      if (!this.aktualisProjekt?.FooterContent) {
        return null;
      }
      return (
        settings.baseUrl +
        'Api/Projekt/GetFooterContentByProjectId/?projectId=' +
        this.aktualisProjekt.Id
      );
    },
  },
  watch: {},
  components: {},
};
</script>
